// extracted by mini-css-extract-plugin
var _1 = "imgBullet-img";
export { _1 as "imgBullet-img" }
